export default "__VITE_ASSET__CdI0M_Be__"